import styled from "@emotion/styled";
import { Box, useTheme } from "@kaltura/mediaspace-shared-styled";
import { KmsTypeComponent } from "@kaltura/mediaspace-shared-types";
import { ErrorBoundary } from "@kaltura/mediaspace-shared-ui";
import { getComponentFromPath, useMediaQuery } from "@kaltura/mediaspace-shared-utils";
import { useButtonAnalytics } from "@kaltura/mediaspace-shared-hooks";

const Container = styled(Box)(({ theme }) => ({
    display: "flex",
    marginTop: theme.spacing(3),
    [theme.breakpoints.down("md")]: {
        justifyContent: "center",
    },
    [theme.breakpoints.down("sm")]: {
        marginTop: theme.spacing(2),
    },
}));

const Action = styled(Box)(({ theme }) => ({
    "&:not(div:first-of-type)": {
        marginLeft: theme.spacing(1),
    },
}));

export interface ActionsProps {
    actions?: KmsTypeComponent[];
}

type AnalyticsProps = {
    action: string;
    buttonType: number;
};

/**
 * Actions in the lobby component
 */
const Actions = (props: ActionsProps) => {
    const { actions = [] } = props;

    const staticClassBase = "kms-ds-media-page-lobby-actions";

    const theme = useTheme();
    const mdButtons = useMediaQuery(theme.breakpoints.down("lg"));

    const sendButtonAnalytics = useButtonAnalytics();

    const sendAnalytics = (analytics?: AnalyticsProps) => {
        if (!analytics) {
            return;
        }
        sendButtonAnalytics(analytics.action, analytics.buttonType);
    };

    return (
        <Container className={staticClassBase}>
            {actions.map((action) => {
                const Component = getComponentFromPath(action.component);
                return (
                    <Action key={action.name} className={`${staticClassBase}-action`}>
                        <ErrorBoundary fallback={<></>}>
                            <Component
                                {...action.props}
                                size={mdButtons ? "medium" : "large"}
                                onClick={() => sendAnalytics(action.props.analytics)}
                            />
                        </ErrorBoundary>
                    </Action>
                );
            })}
        </Container>
    );
};

export default Actions;
